<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم ثبت اطلاعات دستگاه</h5>
    <form [formGroup]="AddNewDevice">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">نام دستگاه (لاتین) </label>
          <input formControlName="Title" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched"
            class="form-text text-muted MyErrorRedColor">نام دستگاه (لاتین) را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"><button type="button" (click)="openModal_QUANTITY(templateQUANTITY)"
              class="btn btn-danger left"> انتخاب زیرکمیت <i class="fa fa-lastfm-square"></i> </button> </label>
          <input type="text" class="form-control" disabled value="{{Data_Seleted_Record.title}}" />
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">OBSERVATION </label>
          <input formControlName="observation" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_observation().valid && get_Form_observation().touched"
            class="form-text text-muted MyErrorRedColor">OBSERVATION را وارد نمائید.</small>
        </div>

      </div>

    </form>

    <br />
    <hr />
    <br />
    <h5> MPE</h5>

    <form [formGroup]="MPEDevice" (submit)="Submit_MPEDevice_Form()">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> مقدار اسمی Min </label>
          <input formControlName="Mpe_Min" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_MPEDevice_Mpe_Min().valid && get_Form_MPEDevice_Mpe_Min().touched"
            class="form-text text-muted MyErrorRedColor">مقدار اسمی Min را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> مقدار اسمی Max </label>
          <input formControlName="Mpe_Max" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_MPEDevice_Mpe_Max().valid && get_Form_MPEDevice_Mpe_Max().touched"
            class="form-text text-muted MyErrorRedColor">مقدار اسمی Max را وارد نمائید.</small>
        </div>

      </div>
      <div class="row">

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> خطای مجاز سیستماتیک </label>
          <input formControlName="Mpe_Sys" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_MPEDevice_Mpe_Sys().valid && get_Form_MPEDevice_Mpe_Sys().touched"
            class="form-text text-muted MyErrorRedColor">خطای مجاز سیستماتیک را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> خطای مجاز تصادفی </label>
          <input formControlName="Mpe_Rnd" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_MPEDevice_Mpe_Rnd().valid && get_Form_MPEDevice_Mpe_Rnd().touched"
            class="form-text text-muted MyErrorRedColor">خطای مجاز تصادفی را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> عدم قطعیت هدف</label>
          <input formControlName="Mpe_Goal" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_MPEDevice_Mpe_Goal().valid && get_Form_MPEDevice_Mpe_Goal().touched"
            class="form-text text-muted MyErrorRedColor">عدم قطعیت هدف را وارد نمائید.</small>
        </div>
      </div>

      <button *ngIf="!InProccessing" type="submit" [disabled]="!MPEDevice.valid" class="btn btn-info"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن MPE </button>
    </form>

    <br />
    <br />

    <div class="table-responsive" *ngIf="Device_MPE_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>مقدار اسمی</th>
            <th>خطای مجاز سیستماتیک </th>
            <th>خطای مجاز تصادفی </th>
            <th>عدم قطعیت هدف</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Device_MPE_List">
            <td>{{Device_MPE_List.indexOf(item)+1}}</td>
            <td>از {{item.mpe_min}} تا {{item.mpe_max}}</td>
            <td>{{item.mpe_sys}}</td>
            <td>{{item.mpe_rnd}}</td>
            <td>{{item.mpe_goal}}</td>
            <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    امکانات
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="Delete_Device_MPE_List(Device_MPE_List.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <hr />
    <br />

    <h5 *ngIf="List_MANUFACTURE_Edit_Id==-1"> سازنده و مدل </h5>
    <h5 *ngIf="List_MANUFACTURE_Edit_Id>-1"> ویرایش سازنده و مدل </h5>

    <br />

    <form [formGroup]="Device_MANUFACTURE_FORM" (submit)="Submit_Device_MANUFACTURE_FORM()">

      <input type="hidden" formControlName="id" value="0" />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> MANUFACTURE </label>
          <input formControlName="MANUFACTURE" type="text" style="font-family: Arial, Helvetica, sans-serif;"
            class="form-control EnglishClm" placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Device_MANUFACTURE_FORM_MANUFACTURE().valid && get_Device_MANUFACTURE_FORM_MANUFACTURE().touched"
            class="form-text text-muted MyErrorRedColor">MANUFACTURE را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> MODEL </label>
          <input formControlName="MODEL" type="text" style="font-family: Arial, Helvetica, sans-serif;"
            class="form-control EnglishClm" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Device_MANUFACTURE_FORM_MODEL().valid && get_Device_MANUFACTURE_FORM_MODEL().touched"
            class="form-text text-muted MyErrorRedColor">MODEL را وارد نمائید.</small>
        </div>
      </div>


      <button *ngIf="!InProccessing && List_MANUFACTURE_Edit_Id>-1" type="submit"
        [disabled]="!Device_MANUFACTURE_FORM.valid" class="btn btn-info" style="margin-left: 5px;"><i
          class="fa  fa-plus-circle"></i> ویرایش سازنده و مدل </button>
      <button *ngIf="!InProccessing && List_MANUFACTURE_Edit_Id>-1" (click)="Reset_MANUFACTURE()" type="button"
        class="btn btn-danger" style="margin-left: 5px;"><i class="fa fa-times-rectangle"></i> لغو ویرایش </button>

    </form>

    <br />
    <hr />
    <br />


    <div>

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">
            Mapping ( jpeg , png , jpg )
            <button (click)="Remove_uploadImage1()" type="button" *ngIf="UploadImageSrc" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file"
            class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
      </div>

      <button type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc" class="btn btn-info"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن ضمینه </button>

      <br />
      <br />

    </div>

    <div class="table-responsive" *ngIf="UploadImageSrc_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            
            <th>عنوان</th>
            <th>فایل</th>

            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of UploadImageSrc_List">

            <td>{{UploadImageSrc_List.indexOf(item.title)+1}}</td>
            <td>
              <input type="text" [(ngModel)]="item.dsc" />
            </td>
            <td>
              <img (click)="openModal(templateImage,item.title)"
                style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Device/{{item.title}}" />
            </td>
            <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    امکانات
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="UploadImageSrc_List_Delete(UploadImageSrc_List.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>



    <br />
    <hr />
    <br />

    <h5> جزئیات سازنده و مدل </h5>

    <br />

    <form [formGroup]="Device_MANUFACTURE_Detail_FORM" (submit)="Submit_Device_MANUFACTURE_Detail_FORM()">

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> RESOLUTION </label>
          <input formControlName="RESOLUTION" type="text" class="form-control EnglishClm"
            style="font-family: Arial, Helvetica, sans-serif;" placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Device_MANUFACTURE_FORM_RESOLUTION().valid && get_Device_MANUFACTURE_FORM_RESOLUTION().touched"
            class="form-text text-muted MyErrorRedColor">RESOLUTION را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> واحد </label>
          <select class="custom-select" formControlName="RESOLUTION_Vahed_id">
            <option value="0">انتخاب کنید</option>
            <option *ngFor="let item of DataList_Unit" [value]="item.id">
              <div innerHTML="{{item.title}}"></div>

            </option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> RANGE MIN </label>
          <input formControlName="RANGE_MIN" type="text" class="form-control EnglishClm"
            style="font-family: Arial, Helvetica, sans-serif;" placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Device_MANUFACTURE_FORM_RANGE_MIN().valid && get_Device_MANUFACTURE_FORM_RANGE_MIN().touched"
            class="form-text text-muted MyErrorRedColor">RANGE MIN را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> RANGE MAX </label>
          <input formControlName="RANGE_MAX" type="text" class="form-control EnglishClm"
            style="font-family: Arial, Helvetica, sans-serif;" placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Device_MANUFACTURE_FORM_RANGE_MAX().valid && get_Device_MANUFACTURE_FORM_RANGE_MAX().touched"
            class="form-text text-muted MyErrorRedColor">RANGE MAX را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> واحد </label>
          <select class="custom-select" formControlName="RANGE_Vahed_id">
            <option value="0">انتخاب کنید</option>
            <option *ngFor="let item of DataList_Unit" [value]="item.id">
              <div innerHTML="{{item.title}}"></div>
            </option>
          </select>
        </div>
      </div>

      <button type="submit" [disabled]="!Device_MANUFACTURE_Detail_FORM.valid" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن به جدول </button>
      <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-left: 5px;"><i
          class="fa fa-times-rectangle"></i> لغو </button>


      <div class="table-responsive" *ngIf="Device_MANUFACTURE_Detail_List.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>RESOLUTION</th>
              <th>RANGE</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Device_MANUFACTURE_Detail_List">
              <td>{{Device_MANUFACTURE_Detail_List.indexOf(item)+1}}</td>
              <td class="EnglishClm">{{item.rESOLUTION}} <div innerHTML="{{item.rESOLUTION_Vahed}}"></div>
              </td>
              <td class="EnglishClm"> {{item.rANGE_MIN}} ... {{item.rANGE_MAX}} <div innerHTML="{{item.rANGE_Vahed}}">
                </div>
              </td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;"
                        (click)="Delete_List_MANUFACTURE_Detail(Device_MANUFACTURE_Detail_List.indexOf(item))"
                        class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </form>



    <br />
    <hr />
    <br />

    <button *ngIf="!InProccessing && List_MANUFACTURE_Edit_Id==-1" type="button"
      (click)="Submit_Device_MANUFACTURE_FORM()" [disabled]="!Device_MANUFACTURE_FORM.valid" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن سازنده و مدل با جزئیات </button>

    <br />
    <br />

    <div class="table-responsive" *ngIf="Device_MANUFACTURE_List.length>0 && List_MANUFACTURE_Edit_Id==-1">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>MANUFACTURE</th>
            <th>MODEL</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of Device_MANUFACTURE_List">
            <tr>
              <td>{{Device_MANUFACTURE_List.indexOf(item)+1}}</td>
              <td class="EnglishClm">{{item.mANUFACTURE}}</td>
              <td class="EnglishClm">{{item.mODEL}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;" (click)="Edot_List_MANUFACTURE(Device_MANUFACTURE_List.indexOf(item))"
                        class="dropdown-item"><i class="fa fa-edit"></i> ویرایش </a>
                      <a style="cursor: pointer;"
                        (click)="Delete_List_MANUFACTURE(Device_MANUFACTURE_List.indexOf(item))"
                        class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <table class="mb-0 table table-bordered table-3 text-center table-striped">
                  <thead style="background-color: #393b9b; color: white;">
                    <tr>
                      <th>#</th>
                      <th>RESOLUTION</th>
                      <th>RANGE</th>
                      <th>امکانات</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let itemDetail of item.detail">
                      <td class="EnglishClm">{{item.detail.indexOf(itemDetail)+1}}</td>

                      <td class="EnglishClm">{{itemDetail.rESOLUTION}} <div innerHTML="{{itemDetail.rESOLUTION_Vahed}}">
                        </div>
                      </td>
                      <td class="EnglishClm"> {{itemDetail.rANGE_MIN}} ... {{itemDetail.rANGE_MAX}} <div
                          innerHTML="{{itemDetail.rANGE_Vahed}}"></div>
                      </td>

                      <td>
                        <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                          <div class="btn-group" role="group">
                            <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              امکانات
                            </button>
                            <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                              <a style="cursor: pointer;"
                                (click)="Delete_List_MANUFACTURE_Detail_INLIST(item.detail.indexOf(itemDetail),Device_MANUFACTURE_List.indexOf(item))"
                                class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>

                  </tbody>
                </table>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <br />
    <hr />
    <br />

    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing" type="button" (click)="SubmitAddNewDevice()" [disabled]="!AddNewDevice.valid"
      class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
    <button routerLink="/Device" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
        class="fa fa-mail-reply"></i> بازگشت </button>
  </div>
</div>

<ng-template #templateQUANTITY>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات زیرکمیت ها </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_QUANTITY.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> عنوان زیرکمیت </label>
          <input type="text" class="form-control" [(ngModel)]="Search_Name_QUANTITY_Table"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>کمیت</th>
              <th>زیرکمیت</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_QUANTITY
            |filter:Search_Name_QUANTITY_Table:'title'
            | paginate
                    : {
                        id: 'DataList_QUANTITY',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_QUANTITY|filter:Search_Name_QUANTITY_Table:'title').length
                      }">
              <td>{{DataList_QUANTITY.indexOf(item)+1}}</td>
              <td>{{item.parentTitle}}</td>
              <td>{{item.title}}</td>
              <td (click)="Set_Selected_QUANTITY_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingQUANTITY" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingQUANTITY" type="button" (click)="ReadData_QUANTITY()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_QUANTITY.hide()">بستن</button>
  </div>
</ng-template>


<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> نمایش عکس </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseUrl}}File/Device/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Device/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> دانلود </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">بستن</button>
  </div>
</ng-template>